import React from 'react'
import { Provider } from 'react-redux';
import { BrowserRouter  } from 'react-router-dom'
import store from './store';
import history from './history'
import Layouts from './layouts'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_API_CLIENT_ID } from './configs/AppConfig';
import './App.css';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          <GoogleOAuthProvider clientId={GOOGLE_API_CLIENT_ID}>
            <Layouts />
          </GoogleOAuthProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
